<template>
    <div>
        <v-card color="primary" dark>
            <v-container>
                <v-flex xs12>
                    <span>{{product.codeView}} - {{product.brand}}</span>
                </v-flex>
            </v-container>
        </v-card>
        <v-card>
            <v-container>
                <v-flex xs12>
                    <span v-if="product.longDesc">{{product.longDesc}}</span>
                    <span v-if="product.ral"> - {{product.ral}}</span>
                    <span v-if="product.colorDesc"> - {{product.colorDesc}}</span>
                </v-flex>
            </v-container>
        </v-card>

        <v-layout row wrap class="mt-3">
            <v-flex xs12 md6 :class="{'pl-0': $vuetify.breakpoint.smAndDown, 'pr-2': $vuetify.breakpoint.mdAndUp}">
                <v-card color="primary" dark>
                    <v-container>
                        <v-flex xs12>
                            <span>{{ $t('Material.ProductDetail.characteristics') }}</span>
                        </v-flex>
                    </v-container>
                </v-card>
                <v-card>
                    <v-container>
                        <v-flex xs12>
                            <v-layout row wrap>
                                <v-flex class="text-xs-center">
                                    <v-img
                                            :src="publicPath + 'img/spruzzo.png'"
                                            height="100"
                                            contain/>
                                    {{ $t('Material.ProductDetail.spray') }}
                                </v-flex>
                                <v-flex class="text-xs-center">
                                    <v-img
                                            :src="getInOutDoorIcon()"
                                            height="100"
                                            contain/>
                                    {{ getInOutDoorLabel() }}
                                </v-flex>
                                <v-flex class="text-xs-center" v-if="product.application">
                                    <v-img
                                           :src="getApplicationIcon()"
                                           height="100"
                                           contain/>
                                    {{ $t('Material.ProductDetail.' + application[product.application].label) }}
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-container>
                </v-card>
            </v-flex>
            <v-flex xs12 md6 :class="{'mt-3': $vuetify.breakpoint.smAndDown, 'pl-2': $vuetify.breakpoint.mdAndUp}">
                <v-card color="primary" dark>
                    <v-container>
                        <v-flex xs12>
                            <span>{{ $t('Material.ProductDetail.baking-conditions') }}</span>
                        </v-flex>
                    </v-container>
                </v-card>
                <v-card>
                    <v-container>
                        <v-flex xs12 lg7 class="pb-4">
                            <table class="baking-conditions">
                                <tr>
                                    <th>{{ $t('Material.ProductDetail.temperature') }}</th>
                                    <th>{{ $t('Material.ProductDetail.time') }}</th>
                                </tr>
                                <tr v-if="!product.tempMinArea">
                                    <td>{{product.tempMin}} {{ $t('Material.ProductDetail.temperature-unit') }}</td>
                                    <td>{{product.timeMin}} {{ product.timeUm }}</td>
                                </tr>
                                <tr v-else >
                                    <td>{{product.tempMinArea}} {{ $t('Material.ProductDetail.temperature-unit') }}</td>
                                    <td>da {{product.timeMinMinArea}} {{ product.timeUm }} a {{product.timeMaxMinArea}} {{ product.timeUm }}</td>
                                </tr>
                                <tr v-if="!product.tempMinArea">
                                    <td>{{product.tempMax}} {{ $t('Material.ProductDetail.temperature-unit') }}</td>
                                    <td>{{product.timeMax}} {{ product.timeUm }}</td>
                                </tr>
                                <tr v-else >
                                    <td>{{product.tempMaxArea}} {{ $t('Material.ProductDetail.temperature-unit') }}</td>
                                    <td>da {{product.timeMinMaxArea}} {{ product.timeUm }} a {{product.timeMaxMaxArea}} {{ product.timeUm }}</td>
                                </tr>
                                
                            </table>
                        </v-flex>
                        <v-flex xs12 lg7>
                            <material-chart 
                                :values="chartValues" 
                                :valuesS2="chartValuesS2" 
                                :x="xAxis" 
                                :labels="{
                                    x: $t('Material.Chart.axis-x-label'),
                                    y: $t('Material.Chart.axis-y-label', {um: product.timeUm})
                                }"></material-chart>
                        </v-flex>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>

        <v-flex xs12 class="mt-5" v-if="!getProfile">
            <hr class="primary mb-3">
            <span style="font-weight: bold">{{ $t('Material.ProductDetail.login-to-download-tds')}}</span>
            <v-flex align-content-end class="text-sm-left">
                <v-btn @click="goToLogin" round dark>{{ $t('Views.Search.access_to_services') }}</v-btn>
            </v-flex>
        </v-flex>
        <v-flex xs12 class="mt-5" v-if="getProfile && hasTds">
            <hr class="primary mb-3">
            <span style="font-weight: bold">{{ $t('Material.ProductDetail.download-tds')}}</span>
            <v-flex align-content-end class="text-sm-left">
                <v-layout row wrap>
                    <v-flex class="text-xs-center" v-for="flag in flagLocales">
                        <v-img
                                style="cursor: pointer"
                                v-bind:key="flag"
                                :src="getFlagIcon(flag)"
                                @click="downloadPdf(flag)"
                                height="60"
                                contain/>
                        {{ getCountry(flag).toUpperCase() }}
                    </v-flex>

                </v-layout>
            </v-flex>
        </v-flex>

        <div class="text-xs-center">
            <v-dialog
                    v-model="isLoading"
                    hide-overlay
                    persistent
                    width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Retrieving data
                        <v-progress-linear
                                indeterminate
                                color="white"
                                class="mb-0"
                        ></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import httpService from '@/service/httpService'
    import downloadService from 'download-service'
    import {mapGetters} from 'vuex'
    import {publicPath} from "../../../vue.config";

    export default Vue.extend({
        name: 'search',
        data() {
            return {
                application: {
                    '2': {file: 'disco', label: 'disc'},
                    '3': {file: 'ezy-realwood', label: 'realwood'},
                    '4': {file: 'forno-gas', label: 'oven'},
                    '5': {file: 'forno-statico', label: 'static-oven'},
                    '6': {file: 'post-forming', label: 'post-forming'},
                    '7': {file: 'tribo', label: 'tribo'},
                },
                flagLocales: ['cs_CZ', 'de_DE', 'en_US', 'es_ES', 'fr_FR', 'hr_HR', 'it_IT', 'pl_PL', 'pt_PT', 'sk_SK'],
                hasTds: false,
                isLoading: false,
                publicPath: publicPath
            }
        },
        props: {
            product: {
                type: Object
            }
        },
        computed: {
            ...mapGetters(['getProfile']),
            getUsername() {
                if (this.getProfile) {
                    return this.getProfile.username
                }
                return 'anonymous'
            },
            chartValues() {
                return !this.product.tempMinArea ? [{
                    x: this.product.tempMin,
                    y: this.product.timeMin
                }, {
                    x: this.product.tempMax,
                    y: this.product.timeMax
                }] : [{
                    x: this.product.tempMinArea,
                    y: this.product.timeMinMinArea
                }, {
                    x: this.product.tempMinArea,
                    y: this.product.timeMaxMinArea
                }, {
                    x: this.product.tempMaxArea,
                    y: this.product.timeMaxMaxArea
                }]
            },
            chartValuesS2() {
                return !this.product.tempMinArea ? [] :[{
                    x: this.product.tempMinArea,
                    y: this.product.timeMinMinArea
                }, {
                    x: this.product.tempMaxArea,
                    y: this.product.timeMinMaxArea
                }, {
                    x: this.product.tempMaxArea,
                    y: this.product.timeMaxMaxArea
                }]
            },
            xAxis() {
                return {
                    min: this.product.tempMinArea ? this.product.tempMinArea - 10 : this.product.tempMin - 10,
                    max: this.product.tempMaxArea ? this.product.tempMaxArea + 10 : this.product.tempMax + 10,
                    step: 10
                }
            }
        },
        mounted() {
            if (this.getProfile) {
                httpService.get('/tds-manager/tds/' + this.product.code + '/public')
                    .then(resp => {
                        this.hasTds = resp
                    })
                    .catch(err => {
                        console.error(err)
                    })
            }

            let _activity = {
                username: this.getUsername,
                activity: 'Search',
                service: 'product-manager',
                params: this.product.code
            }

            httpService.post('/activities', _activity)
                .catch(error => console.error(error))
        },
        methods: {
            goToLogin() {
                this.$router.push({name: 'Login'})
            },
            getApplicationIcon() {
                if (this.application[this.product.application]) {
                    return publicPath + 'img/' + this.application[this.product.application].file + '.png'
                }

                return ''
            },
            getInOutDoorIcon() {
                return this.getInOutDoor().icon
            },
            getInOutDoorLabel() {
                return this.$t('Material.ProductDetail.' + this.getInOutDoor().label)
            },
            getInOutDoor() {
                if (this.product.indoor === 'SI' && this.product.outdoor === 'SI') {
                    return {label: 'inOutdoor', icon: publicPath + 'img/esterno-interno.png'}
                } else if (this.product.indoor === 'NO') {
                    return {label: 'outdoor', icon: publicPath + 'img/esterno.png'}
                } else {
                    return {label: 'indoor', icon: publicPath + 'img/interno.png'}
                }
            },
            getFlagIcon(locale) {
                return publicPath + 'img/flag_' + this.getCountry(locale) + '.png'
            },
            getCountry(locale) {
                return locale.substr(0, 2)
            },
            downloadPdf(locale) {
                this.isLoading = true
                const _product = this.product.code
                const _fileName = 'TDS-' + _product + '-' + locale + '.pdf'

                httpService.get('/tds-manager/exports/tds/' + _product + '/locales/' + locale, {responseType: 'arraybuffer'})
                    .then(response => {
                        downloadService.downloadPdf(response, _fileName)
                    })
                    .catch(error => {
                        console.error(error)
                    })
                    .then(() => this.isLoading = false)
            }
        }
    })
</script>

<style scoped>
    table.baking-conditions {
        width: 100%;
        border-collapse: collapse;
    }

    table.baking-conditions tr {
        border-top: 1px solid black;
        border-bottom: 1px solid black;
    }

    table.baking-conditions tr:first-child {
        background: linear-gradient(60deg, #ef5350, #e53935) !important;
        color: white;
        text-transform: uppercase;
    }

    table.baking-conditions td {
        text-align: center;
        width: 50%;
    }


</style>
